import {blue} from "@ant-design/colors";
import {MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, MenuProps} from "antd";
import React, {FC, memo} from "react";
import {ButtonProps} from "antd/es/button";
import css from "./MoreMenu.less";

type MoreMenuProps = {
    tooltipText?: string;
    moreMenuItems: MenuProps["items"];
    size?: "small" | "middle" | "large";
    style?: React.CSSProperties;
    buttonType?: ButtonProps["type"];
};

const MoreMenu: FC<MoreMenuProps> = ({tooltipText, moreMenuItems = [], size = "small", style, buttonType}) => {
    const Menu = () => {
        return (
            <Dropdown menu={{items: moreMenuItems}} trigger={["click"]} placement="bottomRight">
                <MoreOutlined
                    style={{
                        color: "rgb(7, 96, 255)",
                    }}
                />
            </Dropdown>
        );
    };

    const borderStyle = buttonType ? {} : {border: "1px solid", borderColor: blue[5]};

    return (
        <Button size={size} style={{...borderStyle, ...style}} data-test-id="more-menu-button" type={buttonType}>
            <Menu />
        </Button>
    );
};

export default memo(MoreMenu);
